import React from 'react';
import TimerMixin from "./mixins/TimerMixin";
import PaymentGatewayTesterActions from './actions/PaymentGatewayTesterActions';
import DateHelper from "../DateHelper/DateHelper";
import Switch from "../Switch/Switch";
import { differenceInSeconds } from 'date-fns';
import I18n from 'i18n-js';

class PaymentGatewayTesterHeader extends React.Component {

  constructor(props) {
    super(props);
    this.mixins = [TimerMixin];
    this.waitSeconds = 30;
    this.state = {
      timerEnabled: false
    }

    this.checkTimerEnabled = this.checkTimerEnabled.bind(this);
    this.onChangeDefault = this.onChangeDefault.bind(this);
    this.onChangeLive = this.onChangeLive.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    var now = new Date();
    var tested_successfully_at = DateHelper.local(nextProps.gateway.tested_successfully_at);
    // var diff = now.diff(tested_successfully_at)
    var duration = differenceInSeconds(now, tested_successfully_at);

    this.setState({ timerEnabled: (nextProps.gateway && nextProps.gateway.tested_successfully_at && (this.waitSeconds > duration))});
  }

  componentDidMount() {
    this.setupTestButtonTimer();
  }

  componentDidUpdate() {
    this.setupTestButtonTimer();
  }



  setupTestButtonTimer() {
    var self = this;

    if (this.state.timerEnabled && !this.interval) {
      this.interval = setInterval(function () {
        self.checkTimerEnabled()
      }, 1000);
    } else if (!this.state.timerEnabled && this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  checkTimerEnabled() {
    var now = new Date();
    var tested_successfully_at = DateHelper.local(this.props.gateway.tested_successfully_at);
    // var diff = now.diff(tested_successfully_at)
    var duration = differenceInSeconds(now, tested_successfully_at);

    this.setState({ timerEnabled: (this.props.gateway && this.props.gateway.tested_successfully_at && (this.waitSeconds > duration))});
  }

  render() {
    return (
      <div>
        <div className="row content-center">
          <div className="text-center ">
            <h2>{this.props.currentGatewayOptions ? this.props.currentGatewayOptions[0] : null}</h2>
            <button className="btn btn-secondary" onClick={this.props.onEdit}>{I18n.t('edit_credentials')}</button> &nbsp;
            {this.props.gateway && this.props.gateway.cards && this.props.gateway.cards.length > 0 ? null : <span><button className="btn btn-secondary" onClick={this.props.onDelete}>{I18n.t('delete')}</button> &nbsp;</span>}
            {this.renderTestButton()}
          </div>
        </div>
        <hr />
        {this.renderGatewayKeys()}
        <hr />

        <div className="row flexed content-center" style={{marginBottom: 15}}>
          <div className="col-md-6 text-right">
            <label>{I18n.t('default')} <span className="ss-help help" title={I18n.t('payment_gateway_default_helper_text')}></span></label>
            <Switch
              onText="yes"
              offText="no"
              name="default"
              switchId="default"
              value={this.props.gateway.default}
              onChange={this.onChangeDefault}
            />
          </div>

          <div className="col-md-6">
            <label>{I18n.t('live')} <span className="ss-help help" title={I18n.t('payment_gateway_default_helper_text')}></span></label>
            <Switch
              onText="yes"
              offText="no"
              name="live"
              switchId="live"
              value={this.props.gateway.live}
              onChange={this.onChangeLive}
            />
          </div>
          <div className="text-center">

            {/*<input type="checkbox" ref="default" defaultValue={this.props.gateway.default} />*/}
            {!this.props.gateway.tested_successfully_at ? <div className="alert alert-danger ignore text-center" style={{maxWidth: 338, display: 'block', lineHeight: 1.5, margin: '15px auto 0 auto'}}>{I18n.t('cannot_set_default_gateway_until_tested_successfully')}</div> : null}
          </div>
        </div>
      </div>
    );
  };

  renderTestButton() {
    var now = new Date();
    var tested_successfully_at = DateHelper.local(this.props.gateway.tested_successfully_at);
    // var diff = now.diff(tested_successfully_at)
    var duration = differenceInSeconds(now, tested_successfully_at);

    return (
      <button className="btn btn-secondary" onClick={this.props.onTest} disabled={this.waitSeconds > duration}>
        {this.waitSeconds > duration ? (I18n.t('test_again_in') + ' ' + parseInt(this.waitSeconds - duration) + ' ' + I18n.t('seconds')) : I18n.t('test_gateway')}
      </button>
    );
  };

  renderGatewayKeys = () => {
    return <div className='row content-center gateway-credentials-display-wrapper'>
      {/* <div className='text-center'> */}
        <div className='col-md-2'>
          <div className='form-field'>
            <label>{I18n.t('test_public_key')}</label>
            {this.props.gateway && this.props.gateway.public_test_key ? this.props.gateway.public_test_key : I18n.t('none')}
          </div>
        </div>
        <div className='col-md-2'>
          <div className='form-field'>
            <label className="public-key-display-label">{I18n.t('public_key')}</label>
            {this.props.gateway && this.props.gateway.public_key ? this.props.gateway.public_key : I18n.t('none')}
          </div>
        </div>
      {/* </div> */}
    </div>
  }

  onChangeDefault(e) {
    PaymentGatewayTesterActions.setGatewayDefault(this.props.gateway.id, e.target.checked);
  };

  onChangeLive(e) {
    PaymentGatewayTesterActions.setGatewayLive(this.props.gateway.id, e.target.checked);
  }

};

export default PaymentGatewayTesterHeader
